import Config from "../config/config";
import { http } from "../index";

const Play = ({ gameId,loader}) => {
  return http.get({ url: Config.TableGames.Spin.replace("{gameId}",gameId), loader: loader });
};

const GetJokerToken = ({ loader}) => {
  return http.get({ url: Config.TableGames.GetJokerToken, loader: loader });
};
const GetPokerToken = ({ loader}) => {
  return http.get({ url: Config.TableGames.GetPokerToken, loader: loader });
};
const GetJapaneseToken = ({ loader}) => {
  return http.get({ url: Config.TableGames.GetJapaneseToken, loader: loader });
};
const GetCasinoToken = ({ loader,url}) => {
  return http.get({ url: url, loader: loader });
};


export default {
  Play,
  GetJokerToken,
  GetPokerToken,
  GetJapaneseToken,
  GetCasinoToken
};

